// Types
import type { ErrorAccordionMethodsHandlersType } from './types/error-accordion.handlers.type';
import type { ErrorAccordionComponentType } from 'components/error-accordion/types/error-accordion.type';
// Utilities
import { mapShowErrorAccordingType } from '../utils/error-accordion.utils';

const copyStackTraceErrorButtonClickHandler = ({
  error,
}: Pick<ErrorAccordionComponentType, 'error'>): void => {
  window.navigator.clipboard.writeText(mapShowErrorAccordingType(error));
};

const ErrorAccordionHandlers = (
  props: Pick<ErrorAccordionComponentType, 'error'>
): ErrorAccordionMethodsHandlersType => ({
  handleCopyStackTraceErrorButtonClick: () => copyStackTraceErrorButtonClickHandler(props),
});

export { ErrorAccordionHandlers };
